var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStressElevated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4514_2547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9094 0 0 17.9094 0 40C0 62.0906 17.9094 80 40 80C62.0906 80 80 62.0906 80 40C80 17.9094 62.0906 0 40 0ZM20 30C20 27.2391 22.2391 25 25 25C27.7609 25 30 27.2391 30 30C30 32.7609 27.7609 35 25 35C22.2391 35 20 32.7609 20 30ZM52.5 60H27.5C26.1203 60 25 58.8797 25 57.5C25 56.1203 26.1203 55 27.5 55H52.5C53.8797 55 55 56.1203 55 57.5C55 58.8797 53.8797 60 52.5 60ZM55 35C52.2391 35 50 32.7609 50 30C50 27.2391 52.2391 25 55 25C57.7609 25 60 27.2391 60 30C60 32.7609 57.7609 35 55 35Z",
    fill: "#FAC02B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4514_2547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressElevated);
export default __webpack_public_path__ + "static/media/StressElevated.77d5bd43f8bcb7adcdb4cb3b2ae747db.svg";
export { ForwardRef as ReactComponent };